export function extractErrorMessage(error: string): string {
  let message = '';

  if (error.includes('CustomException:')) {
    message = error.split('CustomException:').slice(1).join('CustomException:').trim();
  } else {
    message = error.split(':').slice(1).join(':').trim();
  }


  message = (message.includes('java') || message.includes('sql'))
    ? 'Ha ocurrido un error en el servicio'
    : message;

  return message.length ? message : error;
}
